module.exports = __webpack_public_path__ + "static/media/chhitosewa.f016df14.png";